(() => {
  function initializeCatalog(root) {
    if (root.dataset.scReady) return;
    const grid = root.querySelector('[data-sc-grid]');
    if (!grid) return;
    const cards = [...grid.querySelectorAll('[data-sc-product-card]')];
    const query = root.querySelector('[data-sc-query]');
    const sort = root.querySelector('[data-sc-sort]');
    const tabs = [...root.querySelectorAll('[data-sc-category]')];
    const count = root.querySelector('[data-sc-count]');
    const empty = root.querySelector('[data-sc-empty]');
    const clear = root.querySelector('[data-sc-clear]');
    let category = 'all';
    const normalize = value => value.normalize('NFKC').toLocaleLowerCase().trim();
    const originalOrder = new Map(cards.map((card, index) => [card, index]));
    const update = () => {
      const term = normalize(query?.value || '');
      const direction = sort?.value || 'featured';
      let visible = 0;
      const sorted = [...cards].sort((a, b) => {
        const difference = Number(a.dataset.price) - Number(b.dataset.price);
        if (direction === 'price-asc') return difference || originalOrder.get(a) - originalOrder.get(b);
        if (direction === 'price-desc') return -difference || originalOrder.get(a) - originalOrder.get(b);
        return originalOrder.get(a) - originalOrder.get(b);
      });
      const fragment = document.createDocumentFragment();
      sorted.forEach(card => {
        card.hidden = (category !== 'all' && card.dataset.category !== category) || !normalize(card.dataset.search || '').includes(term);
        if (!card.hidden) visible += 1;
        fragment.append(card);
      });
      grid.append(fragment);
      const countTemplate = visible === 1 ? root.dataset.countOneTemplate : root.dataset.countTemplate;
      if (count) count.textContent = (countTemplate || root.dataset.countTemplate || '__COUNT__').replace('__COUNT__', String(visible));
      if (empty) empty.hidden = visible !== 0;
      if (clear) clear.hidden = visible !== 0 || (!term && category === 'all');
      tabs.forEach(tab => {
        const selected = tab.dataset.scCategory === category;
        tab.classList.toggle('selected', selected);
        tab.setAttribute('aria-pressed', String(selected));
      });
    };
    query?.addEventListener('input', update);
    sort?.addEventListener('change', update);
    tabs.forEach(tab => tab.addEventListener('click', () => { category = tab.dataset.scCategory; update(); }));
    clear?.addEventListener('click', () => { category = 'all'; if (query) query.value = ''; update(); query?.focus(); });
    root.querySelector('[data-sc-catalog-tools]')?.removeAttribute('hidden');
    root.dataset.scReady = 'true';
    update();
  }
  const initialize = scope => {
    if (scope.matches?.('[data-sc-catalog]')) initializeCatalog(scope);
    scope.querySelectorAll('[data-sc-catalog]').forEach(initializeCatalog);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
